const env = {
  baseUrl: "https://api.utirx.com/backend/",
};

export default env;
